export const randomChar = (
  alphabet = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
) => alphabet[Math.floor(Math.random() * alphabet.length)];
